module.exports = __webpack_public_path__ + "img/Fiche chargé organisation évènements Hebdomadaire.a7a4a691.jpg";